import React from "react";
import PrescriptionTab from "../prescriptionTab/PrescriptionTab";
import useHistoryScope from "./useHistoryScope";

/**
 * History → Prescription.
 *
 * `PrescriptionTab` owns the data (the paged `/history/prescription`
 * endpoint), the list/detail split and — in the client workspace only — the
 * regenerate/edit/delete flows. It reads the scope itself, so this wrapper
 * only supplies the per-scope filter key: the cross-client view's Client
 * filter must not follow the user into a single-subject page, where that
 * column does not exist.
 */
const PrescriptionHistoryTab = () => {
  const { kind } = useHistoryScope();
  return <PrescriptionTab filterPersistKey={`history:${kind}:prescription`} />;
};

export default PrescriptionHistoryTab;
